export default "__VITE_ASSET__B8ZRpTT2__"